import {useState, useCallback, useEffect} from 'react'

const storageName = 'userData'

export const useAuth = () => {
  const [token, setToken] = useState(null)
  const [cubeToken, setCubeToken] = useState(null)
  const [ready, setReady] = useState(false)
  const [userId, setUserId] = useState(null)
  const [userType, setUserType] = useState(null)
  const [user, setUser] = useState(null)

  const login = useCallback((jwtToken, id, userType, userSt, cubeToken) => {
    setToken(jwtToken)
    setUserId(id)
    setUserType(userType)
    setUser(userSt)
    setCubeToken(cubeToken)

    localStorage.setItem(storageName, JSON.stringify({
      userId: id, token: jwtToken, userType: userType, user: userSt
    }))
  }, [])


  const logout = useCallback(() => {
    setToken(null)
    setCubeToken(null)
    setUserId(null)
    setUserType("")
    setUser({})
    localStorage.removeItem(storageName)
  }, [])

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(storageName))
    if (data && data.token) {
      login(data.token, data.userId, data.userType, data.user, data.cubeToken)
    }
    setReady(true)
  }, [login])



  return { login, logout, token, userId, userType, user, ready }
}
